import React, { useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import banner from '../assets/partnerships/partnerships.jpg';
import logo1 from "../assets/partnerships/logo-01.png";
import logo2 from "../assets/partnerships/logo-02.png";
import logo3 from "../assets/partnerships/logo-03.png";
import logo4 from "../assets/partnerships/logo-04.png";
import logo5 from "../assets/partnerships/logo-05.png";
import logo6 from "../assets/partnerships/logo-06.png";
import logo7 from "../assets/partnerships/logo-07.png";

const list = [
  "Rafa Nadal Tennis Program",
  "Chelsea FC Football Centre",
  "NBA Basketball School",
  "BEST Swimming Centre",
  "Nour El Sherbiny Squash Academy",
  "Paulina Nikolova Gymnastics Programme",
  "Kings Polo Academy"];

const Partnerships = () => {
  const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7];
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true,});
    const scrollContainer = scrollContainerRef.current;
    let isScrolling;
    if (scrollContainer) {
    const handleScroll = () => {scrollContainer.classList.add("scrolling"); clearTimeout(isScrolling); isScrolling = setTimeout(() => {scrollContainer.classList.remove("scrolling");}, 500);};
    scrollContainer.addEventListener("scroll", handleScroll);
    return () => {scrollContainer.removeEventListener("scroll", handleScroll);};}}, []);

  return (
  <><div className="flex flex-col md:flex-row items-center md:items-start w-full text-blue font-tenor md:mt-4"><div className="md:hidden mb-2" />
    {/* Image Section */}
    <div className="md:w-1/2 w-full overflow-hidden relative" data-aos="fade-right">
    <img src={banner} alt="Expansion"className="w-full h-full transition-transform duration-500 ease-in-out transform hover:scale-110 object-cover object-top"/></div>

    {/* Text Section */}
    <div className="md:w-1/2 w-full items-start mx-auto p-8 md:pt-0" data-aos="fade-up">
    <p className="text-2xl uppercase mb-3 font-bold text-green">Elite Sports Collaborations</p>
    <p className="text-sm md:text-base mb-3">We believe in developing well-rounded individuals through robust extracurricular programs.</p>
          
    <p className="text-sm md:text-base mb-3">Our partnerships include:</p>
    <ol className="space-y-3 text-sm md:text-base">
    {list.map((item, index) => (
    <li key={index} className="relative pl-10 text-blue">
    <span className="absolute left-0 top-0 text-green">➜</span>
    {item}</li>))}</ol></div></div>

    {/* Partner Logos Section */}
    <div className="w-full p-8 bg-blue relative" data-aos="fade-up">
    <div ref={scrollContainerRef} className="overflow-x-auto flex scrollbar-thin scrollbar-thumb-white scrollbar-track-transparent custom-scrollbar">
    {logos.map((logo, index) => (
    <div key={index} className="flex-shrink-0 w-32 md:w-40 mb-8">
    <img src={logo} alt={`Partner ${index + 1}`} className="w-full h-auto transition-transform duration-300 ease-in-out hover:scale-105" /></div>))}</div></div></>);};

export default Partnerships;